/* =========================================================
   nümashome — theme.js
   Interacciones del tema: marca animada, revelado al scroll,
   cabecera compacta, menú móvil, newsletter, añadir rápido.
   ========================================================= */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Marca abstracta animada (trazo continuo) ---------- */
  function initBrandMarks() {
    var marks = Array.prototype.slice.call(document.querySelectorAll('.js-brand-mark'));
    marks.forEach(function (svg, i) {
      var path = svg.querySelector('.mark-path');
      var dot = svg.querySelector('.mark-dot');
      if (!path || !dot) return;
      var len = path.getTotalLength();
      path.style.strokeDasharray = len;

      if (reducedMotion) {
        path.style.strokeDashoffset = 0;
        dot.style.opacity = 0;
        return;
      }

      var duration = 2600;
      var pause = 850;
      var cycle = duration + pause;
      var stagger = i * 260;
      var start = null;

      function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

      function frame(ts) {
        if (start === null) start = ts;
        var elapsed = (ts - start + stagger) % cycle;
        if (elapsed <= duration) {
          var t = easeOutCubic(elapsed / duration);
          path.style.strokeDashoffset = len * (1 - t);
          var pt = path.getPointAtLength(len * t);
          dot.setAttribute('cx', pt.x);
          dot.setAttribute('cy', pt.y);
          dot.style.opacity = 1;
        } else {
          path.style.strokeDashoffset = 0;
          dot.style.opacity = 0;
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  /* ---------- 2. Revelado de secciones al hacer scroll ---------- */
  function initScrollReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-reveal-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- 3. Foto de hero: revelado al cargar ---------- */
  function initHeroReveal() {
    var frame = document.querySelector('.hero-photo-frame');
    if (!frame) return;
    if (reducedMotion) return;
    frame.classList.add('reveal-ready');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        frame.classList.add('reveal-in');
      });
    });
  }

  /* ---------- 4. Cabecera compacta al hacer scroll ---------- */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var lastState = false;
    function onScroll() {
      var scrolled = window.scrollY > 24;
      if (scrolled !== lastState) {
        header.classList.toggle('is-scrolled', scrolled);
        lastState = scrolled;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 5. Menú móvil (drawer) ---------- */
  function initMobileNav() {
  var toggle = document.querySelector('.nav-toggle');
  var drawer = document.querySelector('.mobile-drawer');
  var overlay = document.querySelector('.drawer-overlay');
  var close = document.querySelector('.drawer-close');

  if (!toggle || !drawer || !overlay) return;

  if (!drawer.querySelector('.numa-mobile-art')) {
    var art = document.createElement('div');
    art.className = 'numa-mobile-art';
    art.setAttribute('aria-hidden', 'true');

    art.innerHTML =
      '<svg viewBox="0 0 500 700" fill="none">' +
        '<path d="M-40 180C140 10 180 330 365 174C440 111 425 38 560 4"/>' +
        '<path d="M-20 590C130 400 258 680 366 520C425 434 486 405 560 450"/>' +
        '<circle cx="350" cy="180" r="10"/>' +
      '</svg>';

    drawer.prepend(art);
  }

  function open() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    toggle.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(function () {
      drawer.classList.add('is-ready');
    });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open', 'is-ready');
    overlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', open);
  overlay.addEventListener('click', closeDrawer);

  if (close) {
    close.addEventListener('click', closeDrawer);
  }

  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });
}

  /* ---------- 6. Newsletter: feedback tras enviar ---------- */
  function initNewsletterForms() {
    var forms = document.querySelectorAll('.nl-form');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        // Shopify procesa el envío real (acción del formulario de cliente);
        // aquí solo damos feedback visual inmediato.
        var msg = form.parentElement.querySelector('.newsletter-msg');
        form.classList.add('is-success');
        if (msg) {
          msg.textContent = '¡Gracias! Revisa tu correo para confirmar.';
          msg.classList.add('is-visible');
        }
      });
    });
  }

  /* ---------- 7. Añadir rápido: micro-animación en el carrito ---------- */
  function initQuickAdd() {
    var buttons = document.querySelectorAll('.js-quick-add');
    var cartCount = document.querySelector('.cart-count');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var form = btn.closest('form');
        if (!form) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Añadiendo…';
        try {
          var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('No se pudo añadir el producto');
          btn.textContent = 'Añadido ✓';
          btn.classList.add('is-added');
          if (cartCount) {
            var current = Number(cartCount.getAttribute('data-count') || '0') + 1;
            cartCount.setAttribute('data-count', current);
            cartCount.textContent = current;
            cartCount.classList.add('is-visible');
            cartCount.classList.remove('is-bumped');
            void cartCount.offsetWidth;
            cartCount.classList.add('is-bumped');
          }
        } catch (error) {
          btn.textContent = 'Inténtalo de nuevo';
        }
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      });
    });
  }

  /* ---------- 8. Escultura de capas: parallax suave ---------- */
  function initLayerSculpture() {
    if (reducedMotion) return;
    document.querySelectorAll('.js-layer-sculpture').forEach(function (sculpture) {
      var svg = sculpture.querySelector('.layer-sculpture__svg');
      if (!svg) return;
      sculpture.addEventListener('pointermove', function (event) {
        var rect = sculpture.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        svg.style.transform = 'perspective(700px) rotateX(' + (-y * 7) + 'deg) rotateY(' + (x * 7) + 'deg)';
      });
      sculpture.addEventListener('pointerleave', function () { svg.style.transform = ''; });
    });
  }

  /* ---------- 0. Trazo decorativo grande en el hero (mismo dibujo que el logo, a mayor tamaño) ---------- */
  function initHeroFlourish() {
    var heroCopy = document.querySelector('.hero-copy');
    if (!heroCopy || heroCopy.querySelector('.hero-flourish')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'hero-flourish';
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.innerHTML =
      '<svg class="js-brand-mark" viewBox="0 0 60 60" fill="none" width="100%" height="100%">' +
      '<path class="mark-path" d="M30,6 C40,6 48,14 46,24 C44,34 34,36 28,30 C24,26 26,20 32,20 C36,20 38,24 34,26 C40,30 46,26 48,36 C50,48 40,54 28,52 C14,50 6,40 8,28 C10,16 20,6 30,6"/>' +
      '<circle class="mark-dot" r="2.4" cx="30" cy="6"/>' +
      '</svg>';
    heroCopy.insertBefore(wrapper, heroCopy.firstChild);
  }
function initCartLines() {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  function createLines() {
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner || inner.querySelector('#NumaCartLines')) return;

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('id', 'NumaCartLines');
    svg.setAttribute('viewBox', '0 0 500 850');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');

    var lineOne = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    lineOne.setAttribute(
      'd',
      'M -90 190 C 110 10, 255 390, 590 130 C 390 410, 130 350, -80 650'
    );

    var lineTwo = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    lineTwo.setAttribute(
      'd',
      'M 580 700 C 320 570, 360 290, 80 350 C -40 390, 100 110, 480 20'
    );

    svg.appendChild(lineOne);
    svg.appendChild(lineTwo);
    inner.prepend(svg);
  }

  var observer = new MutationObserver(function () {
    if (drawer.classList.contains('active')) {
      requestAnimationFrame(createLines);
    }
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });
}
function initCollectionsCanvas() {
  var page = document.querySelector('.numa-collections-page');
  if (!page) return;

  var canvas = document.createElement('canvas');
  canvas.id = 'numa-collections-canvas';
  page.prepend(canvas);

  var ctx = canvas.getContext('2d');
  var lines = [];

  function makeLine(index) {
    var width = page.offsetWidth;
    var height = page.offsetHeight;

    return {
      color: index === 0 ? '#b5502a' : '#211d18',
      opacity: index === 0 ? 0.28 : 0.16,
      width: index === 0 ? 1.35 : 0.85,
      x1: index === 0 ? -120 : width + 100,
      y1: Math.random() * height,
      x2: index === 0 ? width + 120 : -100,
      y2: Math.random() * height,
      c1x: Math.random() * width,
      c1y: Math.random() * height,
      c2x: Math.random() * width,
      c2y: Math.random() * height,
      speed: index === 0 ? 0.00018 : -0.00013,
      phase: Math.random() * Math.PI * 2,
      amplitude: 65 + Math.random() * 90
    };
  }

  function resize() {
    var ratio = window.devicePixelRatio || 1;
    var width = page.offsetWidth;
    var height = page.offsetHeight;

    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';

    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

    lines = [makeLine(0), makeLine(1)];
  }

  function draw(time) {
    var width = page.offsetWidth;
    var height = page.offsetHeight;

    ctx.clearRect(0, 0, width, height);

    lines.forEach(function (line) {
      var t = time * line.speed + line.phase;
      var moveA = Math.sin(t) * line.amplitude;
      var moveB = Math.cos(t * 1.3) * line.amplitude;
      var moveC = Math.sin(t * 0.7) * line.amplitude;

      ctx.beginPath();
      ctx.strokeStyle = line.color;
      ctx.globalAlpha = line.opacity;
      ctx.lineWidth = line.width;
      ctx.lineCap = 'round';

      ctx.moveTo(line.x1, line.y1 + moveA);
      ctx.bezierCurveTo(
        line.c1x + moveB,
        line.c1y + moveC,
        line.c2x - moveC,
        line.c2y - moveA,
        line.x2,
        line.y2 + moveB
      );

      ctx.stroke();
    });

    ctx.globalAlpha = 1;
    requestAnimationFrame(draw);
  }

  resize();
  new ResizeObserver(resize).observe(page);
  requestAnimationFrame(draw);
}

function initCollectionsCarousel() {
  var carousel = document.querySelector('#colecciones .collections');
  if (!carousel) return;

  var paused = false;
  var timer;

  function nextSlide() {
    if (paused) return;

    var card = carousel.querySelector('.collection-card');
    if (!card) return;

    var step = card.getBoundingClientRect().width + 16;
    var end = carousel.scrollWidth - carousel.clientWidth - 10;

    if (carousel.scrollLeft >= end) {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: step, behavior: 'smooth' });
    }
  }

  function start() {
    clearInterval(timer);
    timer = setInterval(nextSlide, 4200);
  }

  carousel.addEventListener('mouseenter', function () {
    paused = true;
  });

  carousel.addEventListener('mouseleave', function () {
    paused = false;
  });

  carousel.addEventListener('touchstart', function () {
    paused = true;
  }, { passive: true });

  carousel.addEventListener('touchend', function () {
    setTimeout(function () {
      paused = false;
    }, 1800);
  }, { passive: true });

  start();
}
function initProductWishlist() {
  var key = 'numa-wishlist';

  function getItems() {
    return JSON.parse(localStorage.getItem(key) || '[]');
  }

  function showMessage(text) {
    var oldToast = document.querySelector('.numa-wishlist-toast');
    if (oldToast) oldToast.remove();

    var toast = document.createElement('div');
    toast.className = 'numa-wishlist-toast';
    toast.textContent = text;
    document.body.appendChild(toast);

    setTimeout(function () {
      toast.remove();
    }, 2500);
  }

  function syncButton(button) {
    var items = getItems();
    var active = items.indexOf(button.dataset.wishlistHandle) !== -1;

    button.classList.toggle('is-active', active);
    button.setAttribute(
      'aria-label',
      active ? 'Quitar de favoritos' : 'Añadir a favoritos'
    );
  }

  document.querySelectorAll('.numa-wishlist-button').forEach(syncButton);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.numa-wishlist-button');
    if (!button) return;

    event.preventDefault();

    var handle = button.dataset.wishlistHandle;
    var items = getItems();
    var index = items.indexOf(handle);
    var added = index === -1;

    if (added) {
      items.push(handle);
    } else {
      items.splice(index, 1);
    }

    localStorage.setItem(key, JSON.stringify(items));

    button.classList.remove('is-popping');
    void button.offsetWidth;
    button.classList.add('is-popping');

    syncButton(button);
    showMessage(added ? 'Añadido a favoritos' : 'Eliminado de favoritos');
  });
}
function initMobileProductScroll() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  if (!document.querySelector('product-info')) return;

  function unlockProductPage() {
    var cartOpen = document.querySelector('cart-drawer.active');
    var menuOpen = document.querySelector('.mobile-drawer.is-open');

    if (!cartOpen && !menuOpen) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  unlockProductPage();
  window.addEventListener('pageshow', unlockProductPage);
}
  document.addEventListener('DOMContentLoaded', function () {

    function initNumaCartTrigger() {
  var button = document.querySelector('#numa-cart-icon');
  var drawer = document.querySelector('cart-drawer');

  if (!button || !drawer) return;

  button.addEventListener('click', function () {
    drawer.open(button);
  });
}
    initMobileProductScroll();
    initProductWishlist();
    initCollectionsCarousel();
    initCollectionsCanvas();
    initCartLines();
    initHeroFlourish();
    initBrandMarks();
    initScrollReveal();
    initHeroReveal();
    initStickyHeader();
    initMobileNav();
    initNewsletterForms();
    initQuickAdd();
    initLayerSculpture();
  });
})();
